<template>
  <div v-if="visible" class="template template-notebook">
    <div class="tn-header">
      <div class="tn-red-line"></div>
      <h2 class="tn-title">记账</h2>
    </div>
    <div v-if="discountSummary" class="tn-discount-info">
      <span>原价 {{ discountSummary.totalOriginal }} | 优惠 -{{ discountSummary.totalDiscount }} | 实付 {{ discountSummary.finalTotal }}</span>
    </div>
    <div class="tn-lines">
      <div v-for="(item, i) in resultList" :key="i" class="tn-row">
        <span class="tn-name">{{ item.name }}</span>
        <span class="tn-pay">付 {{ item.payAmount.toFixed(2) }}</span>
        <span :class="['tn-result', item.type === '应退' ? 'green' : 'red']">
          {{ item.type === '应退' ? '收' : '付' }} {{ item.finalAmount.toFixed(2) }}
        </span>
      </div>
    </div>
    <div class="tn-footer-line"></div>
    <p class="tn-total">总计：{{ totalAmount }} 元</p>
    <p class="tn-date">{{ dateStr }}</p>
  </div>
</template>

<script>
export default {
  name: 'TemplateNotebook',
  props: {
    resultList: { type: Array, default: () => [] },
    form: { type: Object, default: () => ({}) },
    visible: { type: Boolean, default: false },
    discountSummary: { type: Object, default: null }
  },
  computed: {
    dateStr() {
      return new Date().toLocaleDateString()
    },
    totalAmount() {
      if (this.discountSummary) return this.discountSummary.finalTotal.toFixed(2)
      return this.resultList.reduce((s, r) => s + r.payAmount, 0).toFixed(2)
    }
  }
}
</script>

<style scoped>
.template-notebook {
  width: 375px;
  background: #fffef9;
  padding: 20px;
  font-family: 'Segoe Script', 'Comic Sans MS', 'KaiTi', cursive, sans-serif;
  color: #2d3748;
  box-sizing: border-box;
  background-image:
    repeating-linear-gradient(
      transparent, transparent 31px,
      #e8ecf0 31px, #e8ecf0 32px
    );
  background-size: 100% 32px;
}

.tn-header {
  margin-bottom: 16px;
}

.tn-red-line {
  height: 3px;
  background: #e53e3e;
  margin-bottom: 6px;
  border-radius: 1px;
}

.tn-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #2d3748;
}

.tn-discount-info {
  text-align: center;
  font-size: 12px;
  color: #667eea;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #cbd5e0;
}

.tn-lines {
  margin-bottom: 8px;
}

.tn-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  line-height: 32px;
}

.tn-name {
  font-weight: 600;
  font-size: 14px;
  min-width: 50px;
}

.tn-pay {
  color: #718096;
  font-size: 13px;
}

.tn-result {
  font-weight: 700;
  font-size: 13px;
  min-width: 80px;
  text-align: right;
}

.tn-result.green {
  color: #276749;
}

.tn-result.red {
  color: #c53030;
}

.tn-footer-line {
  height: 2px;
  background: #cbd5e0;
  margin: 8px 0;
  border-radius: 1px;
}

.tn-total {
  font-size: 14px;
  font-weight: 700;
  margin: 4px 0;
  color: #4a5568;
}

.tn-date {
  font-size: 12px;
  color: #a0aec0;
  margin: 4px 0 0;
}
</style>
